import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationFreeTextPluginService } from './free-text.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ConfirmComponent } from '../../../modal/confirm.component';

@Component({
    selector: 'installation-free-text-edit',
    templateUrl: './free-text-edit.component.html',
    standalone: false
})
export class InstallationFreeTextEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  currentItem: any;

  private textToRemove: number;

  private sub = new Subscription();

  @ViewChild('textDeleteConfirm', { static: true }) textDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationFreeTextPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['textes'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateFreeText(this.inspectionId, this.pointId, this.pluginId, model.textes).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['textes'];
    control.push(this.initText());
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['textes'];
    control.removeAt(this.textToRemove);
  }

  public openTextDeleteConfirm(i: number) {
    this.textDeleteConfirm.open();
    this.textToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      if (!this.plugin.config.Textes?.length) {
        this.plugin.config.Textes = this.plugin.config.HtmlContent
          ? [{ HtmlContent: this.plugin.config.HtmlContent, Label: this.plugin.config.Label }]
          : [];

        this.plugin.config.HtmlContent = null;
        this.plugin.config.Label = null;
      }
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      textes: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['textes'];
    _.forEach(this.plugin.config.Textes, (el) => {
      control.push(this.initText(el));
    });
  }

  private initText(el?: any) {
    return this.fb.group({
      Label: new UntypedFormControl(el?.Label ?? ''),
      HtmlContent: new UntypedFormControl(el?.HtmlContent ?? '')
    });
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '20rem',
    minHeight: '5rem',
    width: '60vw',
    placeholder: 'Enter text here...',
    translate: 'no',
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'heading',
        'fontName',
        'fontSize',
        'textColor',
        'backgroundColor',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };
}
